import { Component, ChangeDetectionStrategy } from "@angular/core";

import { TeamPageSettingsService } from "../../team-page-settings.service";
import { UserSummaryContactService } from "@onsip/common/services/api/resources/userSummaryContact/user-summary-contact.service";
import { OrganizationCustomizationService } from "@onsip/common/services/api/resources/organizationCustomization/organization-customization.service";

import { TeamSettingsPreviewContentComponent } from "./preview-content.component";

@Component({
  selector: "onsip-team-settings-web-preview",
  templateUrl: "./web/web-preview.component.html",
  styleUrls: ["./web/web-preview.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TeamSettingsWebPreviewComponent extends TeamSettingsPreviewContentComponent {
  constructor(
    protected settings: TeamPageSettingsService,
    protected userSummaryContact: UserSummaryContactService,
    protected organizationCustomization: OrganizationCustomizationService
  ) {
    super(settings, userSummaryContact, organizationCustomization);
  }
}
